import React, { Component } from 'react';
import { Table, Row, Col, Container, Spinner, Button, Input } from 'reactstrap';
import { Card, CardHeader, CardBody, CardFooter, CardText, Alert } from 'reactstrap';
import { Nav, NavItem, NavLink} from 'reactstrap';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import Popout from './Popout';
import { RiShieldStarFill } from "react-icons/ri";
import { GiCancel, GiConfirmed } from 'react-icons/gi';
import { AppContext } from '../AppContext';
import shark from './Imagenes/IconInsignias/shark.svg';
import sostenibilidad from './Imagenes/IconInsignias/ciudadania-ETICA.svg';
import liderazgo from './Imagenes/IconInsignias/liderazgo-AUTOAGENCIA.svg';
import creatibidad from './Imagenes/IconInsignias/CREATIVIDAD.svg';
import interaccion from './Imagenes/IconInsignias/interaccion-COMUNICACION.svg';
import autonomia from './Imagenes/IconInsignias/Autonomia-APRENDIZAJE.svg';
import estrategia from './Imagenes/IconInsignias/Gestion-ESTRATEGICA.svg';
import AllPagesPDFViewer from './All-page';
import DownloadButton from './DownloadButton';

/*const localBack = url.localBack;*/
const localBack = process.env.REACT_APP_BACK;
const homepage = process.env.REACT_APP_EXP;

const iconInsignia = [shark, sostenibilidad, liderazgo, creatibidad, interaccion, autonomia, estrategia];

export class Reporte extends Component {
  static displayName = Reporte.name;

  constructor(props) {
    super(props);
      this.state = {
          iduser: 0,
          nombreCompleto: '',
          codigo: '',
          certificado: '',
          activeTab: 0,
          selectpage: 1,
          ultimoCambio: '2022/05/30T13:00',                    
          actividades: [],
          insignias: [],
          categorias: [],
          tipos: [],
          entidades: [],
          idsSeleccionadas: [],
          allselectA: true,
          idsInsignias: [],
          allselectI: true,
          loading1: true,
          loading2: true,
          currentActividades: [],
          totalPageA: 0,
          actualPage: 1,
          limite: 6,          
          showPopout: false,
          openModal: false,
          pdfResult: 0,
          pdfResultDownload: -1,
          pdfBase64: undefined,
          pdfBase64Download: undefined,
          agrupacion: 'T',
          Reporte: {
              codigo: '',
              tipo: 'T',
              idestudiante: 0,
              actividades: [],
              insignias: [],
          },
          report: {
              codigo: '',
              tipo: 'T',
              idestudiante: 0,
              actividades: [],
              insignias: [],
          },          
          ArchivoEstado: [{ cod: 'N', nombre: '' }, { cod: 'L', nombre: 'Loading....' }, { cod: 'G', nombre: 'GOOD' }, { cod: 'B', nombre: 'BAD' }],
          fileState: 'N',
      };

      this.handleChangeChk = this.handleChangeChk.bind(this);
      this.handleChangeChkInsignia = this.handleChangeChkInsignia.bind(this);
      this.toggle = this.toggle.bind(this);
      this.page = this.page.bind(this);
      this.onChangeAgrupacion = this.onChangeAgrupacion.bind(this);
  }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            /*console.log(tab);*/
            this.setState({
                activeTab: tab,
                actualPage: 1,
            });
        this.upDateIdsActSelect(tab);
        this.upDateIdsInsigSelect(tab);            
        }
    }

    onChangeAgrupacion(event) {
        //console.log('Cambio Agro');
        //console.log(event.target.value);
        let caracter = event.target.value;
        this.setState({ agrupacion: caracter });
    }

    closeModal() {
        this.setState({ alertModal: false, successReadAlert: false, successSaveAlert: false, errorAlert: false });
    }

    page(num) {
        if (this.state.actualPage !== num) {
            this.setState({
                actualPage: num
            });            
        }
    }

    pagePrevious() {
        if (this.state.actualPage !== 1) {
            let p = this.state.actualPage;
            this.setState({
                actualPage: p - 1 
            });
        }
    }

    pageNext() {
        if (this.state.actualPage !== this.state.totalPageA) {
            let p = this.state.actualPage;
            this.setState({
                actualPage: p + 1
            });
        }
    }

    componentDidMount() {
        let currentUser = this.AppContext;
        this.populateInsigniaData();
        this.getUltimoCambio();
        if (currentUser != null) {
            /*console.log(currentUser);*/
            this.setState({ iduser: currentUser.idpersona, codigo: currentUser.matricula, nombreCompleto: currentUser.nombres + ' ' + currentUser.apellidos });
            this.populateActividad(currentUser.idpersona,"A");
            this.populateInsigniaResult(currentUser.idpersona);
        }
    }

    componentDidUpdate(prevState) {
        const currentUser = this.context;
        if (currentUser != null && this.state.iduser == 0) {
            this.setState({ iduser: currentUser.idpersona, codigo: currentUser.matricula, nombreCompleto: currentUser.nombres + ' ' + currentUser.apellidos });
            this.populateActividad(currentUser.idpersona,"A");
            this.populateInsigniaResult(currentUser.idpersona);
        }        
    }

    renderReporteCard(actividades, insignias) {
        let pagesA = [];
        for (let i = 1; i <= this.state.totalPageA; i++) {
            pagesA.push(<></>);
        }
        return (            
            <>                
                <h1>Certificado</h1>
                <Alert color="primary">
                    <p>
                        El certificado solo incluye las actividades aprobadas e insignias logradas.
                    </p>
                    <p>
                        Ultima Actualizaci&oacute;n: <strong>{this.state.ultimoCambio != null ? this.state.ultimoCambio.split("T")[0] : 'Null'}   {this.state.ultimoCambio != null ? this.state.ultimoCambio.split("T")[1].substring(0, 5) : ''}</strong>.
                    </p>
                </Alert>
                <Nav pills>
                    <NavItem>
                        <NavLink className="icon-pointer" style={{ fontSize: "0.7vw" }} active={0 === this.state.activeTab} onClick={() => { this.toggle(0); }}>
                            Todos
                        </NavLink>
                    </NavItem>
                    {this.state.categorias.map(categoria =>
                        <NavItem>
                            <NavLink className="icon-pointer" style={{ fontSize: "0.7vw" }} active={categoria.idaexinsignia === this.state.activeTab} onClick={() => { this.toggle(categoria.idaexinsignia); }}>
                                {categoria.nombre}
                            </NavLink>
                        </NavItem>
                    )}
                </Nav>
                <div className="py-2">
                    <Card >
                        <CardHeader>Actividades Aprobadas</CardHeader>
                        <CardBody>
                            {this.state.actividades.length == 0 || (this.state.activeTab != 0 && actividades.filter(actividad => actividad.categoria === this.state.activeTab).length == 0)
                                ?
                                <>
                                    <Container fluid>

                                        <Card body className="text-center py-3">

                                            <CardText>No tiene actividades aprobadas por el momento.</CardText>
                                            <CardText>Si tiene actividades en el sistema posiblemente se encuentren en revisi&oacute;n.</CardText>
                                            <CardText>Esto puede revisarlo en la secci&oacute;n de <strong className='icon-pointer' onClick={() => this.goToActividad()}>Actividades</strong>.</CardText>

                                        </Card>

                                    </Container>
                                </>
                                : 
                                <div>
                                    <Pagination hidden={pagesA.length < 1} >
                                        <PaginationItem onClick={() => { this.pagePrevious(); }}>
                                            <PaginationLink previous  />
                                        </PaginationItem>
                                        {pagesA.map((page,i) =>
                                        (
                                            <PaginationItem active={this.state.actualPage === i + 1} onClick={() => { this.page(i+1); }}>
                                            <PaginationLink>
                                                  { i+1 }
                                            </PaginationLink>
                                          </PaginationItem>)
                                        )}
                                        <PaginationItem onClick={() => { this.pageNext(); }}>
                                            <PaginationLink next />
                                        </PaginationItem>
                                    </Pagination>
                                  <Table responsive>
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th hidden={this.state.activeTab !== 0}>Competencia</th>
                                            <th>Tipo Actividad</th>
                                            <th>Nombre de la Actividad</th>
                                            <th>A&ntilde;o</th>
                                            <th>Instituci&oacute;n</th>
                                            <th>
                                                <div><Input type="checkbox" checked={this.state.allselectA} onClick={this.toggleChangeAll} /> Todos</div>
                                            </th>
                                        </tr>
                                    </thead>
                                    {this.state.activeTab === 0 ? 
                                        <tbody>
                                                {actividades.map((act, i) => {
                                                    return <tr id={i} key={i} hidden={!(this.state.actualPage === Math.ceil((i + 1) / this.state.limite))}>
                                                     <td>{(i + 1)}</td>
                                                     <td>{this.state.categorias.filter(cate => cate.idaexinsignia === act.categoria).map(actcat => actcat.nombre)}</td>
                                                     <td>{this.state.tipos.filter(tipo => tipo.idaextipoactividad === act.idaextipoactividad).map(acttipo => acttipo.nombre)}</td>
                                                     <td>{act.nombre}</td>
                                                     <td>{act.anio}</td>
                                                     <td>{this.state.entidades.filter(inst => inst.idaexentidad === act.idinstitucion).map(instE => instE.nombre)}</td>
                                                     <td>
                                                        <Input type="checkbox" name='RA' id={'RA-' + act.idaexregistroactividad} checked={this.state.idsSeleccionadas.includes(act.idaexregistroactividad) ? true : false} onChange={() => this.handleChangeChk(act.idaexregistroactividad)} />
                                                     </td>
                                                </tr>
                                            }                                                
                                            )}
                                        </tbody>
                                        : 
                                        <tbody>
                                            {actividades.filter(actividad => actividad.categoria === this.state.activeTab).map((act, i) => {
                                                return <tr id={i} key={i} hidden={!(this.state.actualPage === Math.ceil((i + 1) / this.state.limite))}>
                                                    <td>{(i + 1)}</td>
                                                    <td>{this.state.tipos.filter(tipo => tipo.idaextipoactividad === act.idaextipoactividad).map(acttipo => acttipo.nombre)}</td>
                                                    <td>{act.nombre}</td>                                                   
                                                    <td>{act.anio}</td>
                                                    <td>{this.state.entidades.filter(inst => inst.idaexentidad === act.idinstitucion).map(instE => instE.nombre)}</td>
                                                    <td >
                                                        <Input type="checkbox" name='RA' id={'RA-' + act.idaexregistroactividad} checked={this.state.idsSeleccionadas.includes(act.idaexregistroactividad) ? true : false} onChange={() => this.handleChangeChk(act.idaexregistroactividad)} />
                                                    </td>
                                                </tr>
                                            }                                                
                                            )}
                                        </tbody>
                                        }
                                    
                                  </Table>
                                </div>
                                }
                            
                        </CardBody>                        
                    </Card> 
                </div>
                
                <div className="py-2">
                    <Card>
                        <CardHeader>Insignias Logradas</CardHeader>
                        <CardBody>
                            {this.state.insignias.length == 0 || (this.state.activeTab != 0 && insignias.filter(insig => insig.idaexinsignia === this.state.activeTab).length == 0)
                                ?
                                <>
                                    <Container fluid>

                                        <Card body className="text-center py-3">
                                            <CardText>Por el momento no ha conseguido ninguna insignia.</CardText>
                                            <CardText>Esto puede revisarlo en la secci&oacute;n de <strong className='icon-pointer' onClick={() => this.goToInsignia()}>Insignias</strong>, en este se refleja el avance de cada una.</CardText>
                                        </Card>

                                    </Container>
                                </>
                                :
                                <Table responsive >
                                    <thead>
                                        <tr>
                                            <th><RiShieldStarFill /></th>
                                            <th>Insignia</th>
                                            <th>Descripci&oacute;n</th>
                                            <th >
                                                <div><Input type="checkbox" checked={this.state.allselectI} onClick={this.toggleChangeAllInsignia} /> Todos</div>
                                            </th>
                                        </tr>
                                    </thead>
                                    {this.state.activeTab === 0
                                        ? <tbody>
                                            {insignias.map((result, i) => {
                                                return <tr id={i} key={i}>
                                                    <td><img src={iconInsignia[result.idaexinsignia]} style={{ width: "30%", height: "30%" }} /></td>
                                                    <td>{result.insignia.nombre}</td>
                                                    <td>{result.insignia.descripcion}</td>
                                                    <td>
                                                        <Input type="checkbox" name='INSIG' id={'INSIG-' + result.idaexresultadoinsignia} checked={this.state.idsInsignias.includes(result.idaexresultadoinsignia) ? true : false} onChange={() => this.handleChangeChkInsignia(result.idaexresultadoinsignia)} />
                                                    </td>
                                                </tr>
                                            }
                                                /*<text>{act.nombre} - {act.anio} - {act.descripcionevid}</text>*/
                                            )}
                                        </tbody>
                                        : <tbody>
                                            {insignias.filter(insig => insig.idaexinsignia === this.state.activeTab).map((result, i) => {
                                                return <tr id={i} key={i}>
                                                    <td><img src={iconInsignia[result.idaexinsignia]} style={{ width: "30%", height: "30%" }} /></td>
                                                    <td>{result.insignia.nombre}</td>
                                                    <td>{result.insignia.descripcion}</td>
                                                    <td >
                                                        <Input type="checkbox" name='INSIG' id={'INSIG-' + result.idaexresultadoinsignia} checked={this.state.idsInsignias.includes(result.idaexresultadoinsignia) ? true : false} onChange={() => this.handleChangeChkInsignia(result.idaexresultadoinsignia)} />
                                                    </td>
                                                </tr>
                                            }
                                                /*<text>{act.nombre} - {act.anio} - {act.descripcionevid}</text>*/
                                            )}
                                        </tbody>
                                    }                                    
                                </Table>
                                }
                            
                        </CardBody>                        
                    </Card>
                </div>                
                <div className="py-2">
                    {this.state.insignias.length > 0 || this.state.actividades.length > 0
                        ? <Row>
                            <Col xs={12} md={2}>Agrupaci&oacute;n: </Col>
                            <Col xs={12} md={4}>
                            <Input  type="select" onChange={this.onChangeAgrupacion} value={this.state.agrupacion} >
                                <option key={"sel-T"} selected={'T' == this.state.agrupacion} value={'T'}>{'Tipo Actividad'}</option>
                                <option key={"sel-C"} selected={'C' == this.state.agrupacion} value={'C'}>{'Competencia'}</option>
                                </Input>
                            </Col>
                            <Col xs={12} md={4}>
                             <Button color="primary" onClick={() => this.generarReporteV2()}>Preview Certificado</Button>
                            </Col>                                                       
                          </Row>
                        : <></>}
                </div>
            </>                
            )
    }

    cerrarModal() {
        this.setState({
            openModal: !this.state.openModal
        });
    }

    render() {        
        let contents = this.state.loading1 || this.state.loading2 ?
            <> <Spinner animation="grow" /></>
            : this.renderReporteCard(this.state.actividades, this.state.insignias);

      return (
          <div>
              <div>
              {contents}        
              </div>
              <div>
                  <Modal size="xl" isOpen={this.state.openModal} toggle={() => this.cerrarModal()} className={this.props.className}>
                      <ModalHeader toggle={() => this.cerrarModal()}>Vista Evidencia</ModalHeader>
                      <ModalBody>
                          <Card body className="all-page-container" style={{ alignContent: 'center', height: '100%', maxHeight: '500px', overflow: 'auto' }}>
                              {this.state.pdfResult > 0 ? <AllPagesPDFViewer pdf={this.state.pdfBase64} /> : <Spinner animation="grow" size='sm' /> }
                          </Card>
                      </ModalBody>
                      <ModalFooter>
                          <label className="control-label col-md-2" htmlFor="Name">{this.state.fileState === 'G' ? <><GiConfirmed /> Good</> : this.state.fileState === 'B' ? <><GiCancel /> Bad</> : this.state.fileState === 'L' ? <Spinner animation="grow" size='sm' /> : <></>}</label>
                          {' '}
                          <Button color={this.state.pdfResultDownload < 0 ? 'primary' : 'secondary'} disabled={this.state.fileState === 'L' || this.state.fileState === 'G' ? 'disabled' : ''} onClick={() => this.generarPdf(this.state.iduser)} >
                              {this.state.fileState === 'N' ? 'Generar' : this.state.fileState === 'L' ? <Spinner animation="grow" size='sm' /> : 'Generar'}
                          </Button>
                          {' '}
                          <Button color="secondary" onClick={() => this.cerrarModal()}>Cancel</Button>
                      </ModalFooter>
                  </Modal>
              </div>
          </div>
    );
    }

    populateInsigniaData() {
        fetch(localBack + '/api/Insignia', {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => response.json())
            .then(data => {
                /*console.log(data);*/
                this.setState({
                    categorias: data.objDatos
                });
            });
        /*console.log(this.state.categorias);*/

        fetch(localBack + '/api/TipoActividad/GetOnlyActive', {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => response.json())
            .then(data => {
                /*console.log(data);*/
                this.setState({
                    tipos: data.objDatos
                });
            });

        fetch(localBack + '/api/Entidad', {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => response.json())
            .then(data => {
                /*console.log(data.strEstado);*/
                this.setState({
                    entidades: data.objDatos,
                    loading: false
                });
            });
        
    }

    getUltimoCambio() {
        fetch(localBack + '/api/ResultadoInsignia/GetUltimoCambio', {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => response.json())
            .then(data => {
                /*console.log('insignia: ', data);*/
                if (data.objDatos != null)
                 this.setState({ ultimoCambio: data.objDatos.ultimoCambio });
                
            });       

    }

    populateInsigniaResult(id) {
        fetch(localBack + '/api/ResultadoInsignia/GetbyEstado/' + id, {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => response.json())
            .then(data => {
                /*console.log('insignia: ', data);*/
                this.setState({ insignias: data.objDatos, loading1: false });
                let ids = [];
                this.state.insignias.map(obj => { ids.push(obj.idaexresultadoinsignia) });
                this.setState({ idsInsignias: ids });
            });
    }

    populateActividad(id,estado) {
        fetch(localBack + '/api/RegistroActividad/GetActByEstado/'+id+'/'+estado, {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => response.json())
            .then(data => {
                /*console.log('criterio: ', data);*/
                this.setState({ actividades: data.objDatos, loading2: false });
                let ids = [];
                this.state.actividades.map(act => { ids.push(act.idaexregistroactividad) });
                this.setState({ idsSeleccionadas: ids });
                this.reLoadTotalPage(this.state.actividades.length, this.state.limite);
            });        
    }

    getPdf(idpersona, codigo) {

        let report = this.state.Reporte;
        report.codigo = codigo;
        report.idestudiante = idpersona;
        report.tipo = this.state.agrupacion;
        report.actividades = this.state.idsSeleccionadas;
        report.insignias = this.state.idsInsignias;

        this.setState({ Reporte: report });
        /*console.log(this.state.Reporte.codigo.length);*/

        const data = JSON.stringify(report);

        fetch(localBack + '/api/Reporte/', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: data,
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => {
                this.setState({ status: response.status });
                return response.json();
            })
            .then(data => {
                /*console.log(data.strMensaje);*/
                if (data.strEstado == 'S') {
                    this.setState({
                        pdfBase64: "data:application/pdf;base64," + data.objDatos + "", pdfResult: 1
                    });
                    /*console.log(this.state.pdfBase64);*/
                } else {
                    this.setState({ pdfResult: -1 });
                }                
            });
    }

    generarPdf(idpersona) {

        let report = this.state.Reporte;        
        report.idestudiante = idpersona;
        report.tipo = this.state.agrupacion;
        report.actividades = this.state.idsSeleccionadas;
        report.insignias = this.state.idsInsignias;        
        this.setState({ Reporte: report, fileState: 'L' });
        /*console.log(this.state.Reporte.codigo.length);*/
        const data = JSON.stringify(report);
        try {
            fetch(localBack + '/api/Reporte/generar', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: data,
                /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
            })
                .then(response => {
                    this.setState({ status: response.status });
                    return response.json();
                })
                .then(data => {
                    /*console.log(data.strMensaje);*/
                    if (data.strEstado == 'S') {
                        this.setState({
                            report: data.objDatos,
                            fileState: 'G'
                        });
                        let codigo = data.objDatos.rutapdf.split(',');
                        this.getPdfGenerado(codigo[1]);                        
                    } else {
                        this.setState({                           
                            fileState: 'B'
                        });
                    }                    
                });
        } catch (ie) {
            this.setState({ fileState: 'B' });
            console.log("Error: " + ie);
        }
    }

    getPdfGenerado(id) {
        let codigo = this.state.report.codigo;        
        fetch(localBack + '/api/FileUpload/DescargarEvidencia/' + id, {
            method: 'GET',
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                if (data !== '') {                    
                    this.setState({
                        pdfBase64Download: "data:application/pdf;base64," + data + "",
                        pdfResultDownload: 1,
                    });
                    let a = document.createElement('a');
                    a.href = "data:application/pdf;base64," + data + "";
                    a.download = "certificado-"+codigo+".pdf";
                    a.click();
                } else {
                    this.setState({ pdfResultDownload: -1 });
                }
            });
    }

    goToInsignia() {
        /*console.log("/Insignia");  */
        this.props.history.push(homepage+"Insignia");
    }

    goToActividad() {
        /*console.log("/Act-Est");*/
        this.props.history.push(homepage+"Act-Est");
    }

    generarReporte() {
        let cod = this.state.codigo;
        let hoy = new Date();
        let hora = `${hoy.getHours()}${hoy.getMinutes()}${hoy.getSeconds()}`;
        let dia = `${hoy.getDate()}${hoy.getMonth() + 1}${hoy.getFullYear()}`;
        let codigoPdf = cod + hora + dia;
        this.setState({ certificado: codigoPdf });
        //console.log("hora: ", hora);
        //console.log("fecha: ", dia);
        //console.log("reporte: ", codigoPdf);
        //console.log("Actividades Selecionadas",this.state.idsSeleccionadas);
        //console.log("Insignias Selecionadas", this.state.idsInsignias);
        this.setPopoutOpen(true);
    }

    generarReporteV2() {
        let cod = this.state.codigo;
        let hoy = new Date();
        let hora = `${hoy.getHours()}${hoy.getMinutes()}`;
        let dia = `${hoy.getDate()}${hoy.getMonth() + 1}${hoy.getFullYear()}`;
        let codigoPdf = cod + hora + dia;
        this.setState({ certificado: codigoPdf });
        this.getPdf(this.state.iduser, codigoPdf);
        this.cerrarModal();
    }

    setPopoutOpen(open) {
        this.setState({
            showPopout: open
        });
    }

    getPopout() {
        let currentUser = this.AppContext;
        let acti = this.state.actividades.filter(activ => this.state.idsSeleccionadas.includes(activ.idaexregistroactividad));
        let insi = this.state.insignias.filter(ing => this.state.idsInsignias.includes(ing.idaexresultadoinsignia));
        let vacio = <Card body className="text-center py-3">
                       <CardText>No tiene actividades o insignias seleccionadas para el reporte.</CardText>
                       <CardText>Por favor, verifique que tenga seleccionada alguna actividad o insignia.</CardText>
                    </Card>;

        let encabezado = <Table>
            <tr><th>Certificado #: </th><td>{this.state.certificado}</td></tr>
            <tr><th>Matricula: </th><td>{this.state.codigo}</td></tr>
            <tr><th>Nombre: </th><td>{this.state.nombreCompleto}</td></tr>            
        </Table>
        let resumen = <Card>{acti.length > 0
            ? <CardBody>
                <Table responsive>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Actividad</th>
                            <th>A&ntilde;o</th>
                            <th>Categor&iacute;a</th>
                            <th>Tipo Actividad</th>                            
                        </tr>
                    </thead>
                    <tbody>
                        {acti.map((act, i) => {
                            return <tr id={i} key={i}>
                                <td>{(i + 1)}</td>
                                <td>{act.nombre}</td>
                                <td>{act.anio}</td>
                                <td>{this.state.categorias.filter(cate => cate.idaexinsignia === act.categoria).map(actcat => actcat.nombre)}</td>
                                <td>{this.state.tipos.filter(tipo => tipo.idaextipoactividad === act.idaextipoactividad).map(acttipo => acttipo.nombre)}</td>                                
                            </tr>
                        }                            
                        )}
                    </tbody>
                </Table>
            </CardBody>
            : <></>}
            {insi.length > 0
                ? <Table responsive >
                    <thead>
                        <tr>
                            <th><RiShieldStarFill /></th>
                            <th>Insignia</th>
                            <th>Descripcion</th>                            
                        </tr>
                    </thead>
                    <tbody>
                        {insi.map((result, i) => {
                            return <tr>
                                <td><img src={iconInsignia[result.idaexinsignia]} style={{ width: "30%", height: "30%" }} /></td>
                                <td>{result.insignia.nombre}</td>
                                <td>{result.insignia.descripcion}</td>                                
                            </tr>
                        }                            
                        )}
                    </tbody>
                </Table>
                : <></>}
        </Card>;

        let generar = <Button className={this.state.pdfResultDownload < 0 ? 'secondary' : 'primary'} onClick={() => this.generarPdf(this.state.iduser)} disabled={this.state.pdfResultDownload > 0 ? '' : 'disabled'}>Generar</Button>

        if (!this.state.showPopout) {
            return null;
        }

        let content = acti.length === 0 && insi.length === 0
            ? <div>{vacio}</div>
            : <div>                
                {this.state.pdfResult > 0 ?
                    <Card body className="all-page-container" style={{ alignContent: 'center', height: '100%', maxHeight: '500px', overflow: 'auto' }}>
                        <AllPagesPDFViewer pdf={this.state.pdfBase64} />                        
                    </Card>
                    : this.state.pdfResult < 0
                        ?
                        <Card body className="text-center py-3">
                            <CardText>Error al generar Preview.</CardText>
                        </Card>
                        :
                        <></>
                }
            </div>

        return (
            <Popout title='Preview Reporte' closeWindow={() => this.setPopoutOpen(false)}>
                <Card>
                    <CardBody>
                        {content}
                    </CardBody>
                    <CardFooter>{generar}</CardFooter>
                </Card>
            </Popout>
        );
    }

    generarCertificado() {
        console.log("#Certificado: ", this.state.certificado);
        console.log("Matricula: ", this.state.codigo);
        console.log("Nombre: ", this.state.nombreCompleto);
        console.log("Actividades: ", this.state.idsSeleccionadas);
        console.log("Insignias: ", this.state.idsInsignias);
    }

    autentica(id) {
        /*console.log("Usuario-Externo/Autentica/" + id);*/
        this.props.history.push("/Externo/Autenticado/" + id);
    }

    handleChangeChk(id) {
        /*console.log(id);*/
        let idlist = this.state.idsSeleccionadas;                  
        if (idlist.includes(id)) {
            let el = idlist.indexOf(id);
            if (el > -1) {
                idlist.splice(el, 1);
            }
        } else {
            idlist.push(id)
        }        
        this.setState({ idsSeleccionadas: idlist });

        if (this.state.idsSeleccionadas.length === this.state.actividades.length) {
            this.setState({ allselectA: true });
        } else {
            this.setState({ allselectA: false });
        }
        /*console.log(this.state.idsSeleccionadas); */       
    }

    toggleChangeAll = e => {          
        if (e.target.checked) {
            let ids = [];
            this.state.actividades.map(act => { ids.push(act.idaexregistroactividad) });
            this.setState({ idsSeleccionadas: ids, allselectA: e.target.checked });            
        } else {
            this.setState({ idsSeleccionadas: [], allselectA: e.target.checked });            
        }
    }

    toggleChangeAllInsignia = e => {
        /*console.log(e.target.checked)*/
        if (e.target.checked) {
            let ids = [];
            this.state.insignias.map(act => { ids.push(act.idaexregistroactividad) });
            this.setState({ idsInsignias: ids, allselectI: e.target.checked });            
        } else {
            this.setState({ idsInsignias: [], allselectI: e.target.checked });
        }
    }
    

    handleChangeChkInsignia(id) {
        /*console.log(id);*/
        let idlist = this.state.idsInsignias;
        if (idlist.includes(id)) {
            let el = idlist.indexOf(id);
            if (el > -1) {
                idlist.splice(el, 1);
            }
        } else {
            idlist.push(id)
        }
        this.setState({ idsInsignias: idlist });

        if (this.state.idsInsignias.length === this.state.insignias.length) {
            this.setState({ allselectI: true });
        } else {
            this.setState({ allselectI: false });
        } 
    }

    upDateIdsActSelect(tab) {
        let ids = [];
        if (tab === 0) {
            /*console.log("todo");*/
            this.state.actividades.map(act => { ids.push(act.idaexregistroactividad) });
            this.reLoadTotalPage(ids.length, this.state.limite);
            this.setState({ idsSeleccionadas: ids });
        } else {
            /*console.log("filtrar: ", tab);*/
            this.state.actividades.filter(actividad => actividad.categoria === tab).map(act => { ids.push(act.idaexregistroactividad) });
            this.reLoadTotalPage(ids.length, this.state.limite);
            this.setState({ idsSeleccionadas: ids  });
        }
        /*console.log(this.state.totalPageA)*/
    }

    upDateIdsInsigSelect(tab) {
        let idsI = [];
        if (tab === 0) {
            this.state.insignias.map(obj => { idsI.push(obj.idaexresultadoinsignia) });
            this.setState({ idsInsignias: idsI });
        } else {
            this.state.insignias.filter(insig => insig.idaexinsignia === tab).map(obj => { idsI.push(obj.idaexresultadoinsignia) });
            this.setState({ idsInsignias: idsI });
        }
    }


    reLoadTotalPage(lenActividades, limite) {
        this.setState({ totalPageA: Math.ceil(lenActividades / limite) });
        /*console.log('Total Paginas: ',this.state.totalPageA);*/
    }

}
Reporte.contextType = AppContext;
